import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { withWidth } from '@material-ui/core';

import {
  MultiStep,
  Step,
  StepConnector,
  Stepper,
} from '../index';

const styles = theme => ({
  containerStepper: {
    margin: `${theme.spacing(2)}px 0`,
    maxWidth: 1024,

    '& .MuiStep-horizontal:first-child': {
      paddingLeft: 0,
    },
    '& .MuiStep-horizontal:last-child': {
      paddingRight: 0,
    },

    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  containerStepperHorizontal: {
    padding: 0,

    [theme.breakpoints.up('sm')]: {
      maxWidth: 1024,
    },
  },
  stepConnectorMain: {
    paddingBottom: 0,

    '& span': {
      borderLeft: 'none',
      borderRight: '1px solid #bdbdbd',
      marginTop: 5,
      marginRight: 60,

      [theme.breakpoints.up('md')]: {
        marginRight: 10,
        marginTop: 0,
      },
    },
  },
  multiStepConnector: {
    maxWidth: 50,
    margin: -10,
    marginTop: -66,

    [theme.breakpoints.up('md')]: {
      margin: 0,
      marginTop: -66,
    },

    '& span': {
      borderTopStyle: 'dashed',
    },
  },
  multiStepConnectorHorizontal: {
    maxHeight: 50,
    marginTop: -106,
    marginLeft: -10,
    marginRight: -10,

    [theme.breakpoints.up('sm')]: {
      margin: theme.spacing(),
      marginLeft: 504,
      paddingBottom: 0,
    },

    '& span': {
      borderTopStyle: 'dashed',

      [theme.breakpoints.up('sm')]: {
        borderLeftStyle: 'dashed',
        borderTop: 'none',
      },
    },
  },
  stepMain: {
    width: 139,

    [theme.breakpoints.up('md')]: {
      width: 240,
    }
  },
  stepperMain: {
    padding: 0,

    '& .stepContainer': {
      width: 139,

      [theme.breakpoints.up('md')]: {
        width: 240,
        height: 40,
        maxHeight: 80,
      }
    },

    '& .stepLabel': {
      maxWidth: 100,
      order: 0,

      [theme.breakpoints.up('md')]: {
        maxWidth: 200,
        textAlign: 'right',
      }
    },

    '& .stepIcon': {
      marginRight: 0,

      [theme.breakpoints.up('md')]: {
        marginRight: theme.spacing(),
      },
    },
  },
  stepperMainHorizontal: {
    padding: 0,

    '& .stepContainer': {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'space-between',

      [theme.breakpoints.up('md')]: {
        maxWidth: 150,
        height: 75,
      }
    },

    '& .stepLabel': {
      order: 2,
      maxWidth: 100,
      margin: `0 ${theme.spacing()}px`,

      [theme.breakpoints.up('sm')]: {
        display: 'flex',
        alignItems: 'flex-end',
        height: 50,
        maxWidth: 200,
        textAlign: 'center',
        order: 0,
      }
    },

    '& .stepIcon': {
      alignSelf: 'center',
    },
  },
  stepperBranch: {
    padding: 0,
    marginTop: 235,

    [theme.breakpoints.up('sm')]: {
      marginTop: 188,
    },

    [theme.breakpoints.up('md')]: {
      marginTop: 144,
    },

    '& .stepContainer': {
      width: 129,

      [theme.breakpoints.up('md')]: {
        width: 240,
        maxHeight: 80,
        justifyContent: 'flex-start',
        height: 40,
      }
    },

    '& .stepLabel': {
      maxWidth: 100,
      order: 0,

      [theme.breakpoints.up('md')]: {
        order: 2,
        maxWidth: 200,
      },
    },

    '& .stepIcon': {
      padding: 0,

      [theme.breakpoints.up('md')]: {
        padding: theme.spacing(),
        paddingLeft: 0,
      }
    }
  },
  stepperBranchHorizontal: {
    justifyContent: 'flex-end',
    padding: 0,
    marginTop: 240,

    [theme.breakpoints.up('sm')]: {
      marginTop: 0,
    },

    '& .stepContainer': {
      flexDirection: 'column',
      justifyContent: 'flex-end',
      height: '100%',

      [theme.breakpoints.up('sm')]: {
        height: 70,
        justifyContent: 'flex-start',
      }
    },

    '& .stepLabel': {
      margin: 0,
      maxWidth: 100,
      textAlign: 'center',

      [theme.breakpoints.up('sm')]: {
        margin: theme.spacing(),
        maxWidth: 156,
      }
    },

    '& .stepIcon': {
      alignSelf: 'center',
    }
  },
  stepConnectorBranch: {
    paddingBottom: 0,

    '& span': {
      height: 60,
      margin: 4,
      marginLeft: 53,

      [theme.breakpoints.up('md')]: {
        marginBottom: 0,
        marginLeft: -2,
      },
    },
  },
  stepConnectorMainHorizontal: {
    margin: 0,
    maxWidth: 20,
    marginLeft: 58,
    marginTop: theme.spacing(),

    [theme.breakpoints.up('sm')]: {
      marginTop: 52,
      marginLeft: 0,
    },
  },
  stepConnectorBranchHorizontal: {
    margin: 0,
    marginLeft: 49,
    marginTop: theme.spacing(),

    [theme.breakpoints.up('sm')]: {
      maxWidth: 60,
      marginTop: -50,
      marginLeft: 0,
    },

    '& span': {
      height: 60,

      [theme.breakpoints.up('sm')]: {
        height: 1,
      }
    },
  },
})

const MultiStepper = ({ classes: c, width, orientation, steps, otherBranchSteps, ...rest }) => {
  const branchSteps = steps.filter(step => otherBranchSteps.includes(step.id));
  const mainSteps = steps.filter(step => !otherBranchSteps.includes(step.id));
  const isHorizontal = orientation === 'horizontal';

  return (
    <Stepper
      orientation={isHorizontal && width !== 'xs' ? 'vertical' : 'horizontal'}
      className={isHorizontal ? c.containerStepperHorizontal : c.containerStepper}
      connector={
        <StepConnector className={isHorizontal ? c.multiStepConnectorHorizontal : c.multiStepConnector} />
      }
    >
      <MultiStep className={isHorizontal ? c.stepMainHorizontal : c.stepMain}>
        <Stepper
          completed='false'
          active='false'
          last='false'
          className={isHorizontal ? c.stepperMainHorizontal : c.stepperMain}
          orientation={ width === 'xs' && orientation === 'horizontal' ? 'vertical' : orientation}
          connector={
            <StepConnector className={isHorizontal ? c.stepConnectorMainHorizontal : c.stepConnectorMain} />
          }
        >
          {mainSteps.map(step => (
            <Step horizontal={isHorizontal} key={step.id} step={step} />
          ))}
        </Stepper>
      </MultiStep>
      <MultiStep>
        <Stepper
          completed='false'
          active='false'
          last='false'
          className={isHorizontal ? c.stepperBranchHorizontal : c.stepperBranch}
          orientation={ width === 'xs' && orientation === 'horizontal' ? 'vertical' : orientation}
          connector={
            <StepConnector className={isHorizontal ? c.stepConnectorBranchHorizontal : c.stepConnectorBranch}/>
          }
        >
          {branchSteps.map(step => (
            <Step horizontal={isHorizontal} className={c.stepRight} key={step.id} step={step} />
          ))}
        </Stepper>
      </MultiStep>
    </Stepper>
  );
}

MultiStepper.defaultProps = {
  orientation: 'horizontal',
}

MultiStepper.propTypes = {
  steps: PropTypes.array.isRequired,
  otherBranchSteps: PropTypes.array.isRequired,
  orientation: PropTypes.oneOf(['horizontal', 'vertical'])
}

export default withStyles(styles)(withWidth()(MultiStepper));



// WEBPACK FOOTER //
// ./src/components/base/MultiStepper/MultiStepper.js